export class LoadBranchesForBrand {
    static readonly type = '[Branches] Load Branches For Brand';
    constructor(public brandId: number) {}
}
